module.exports = __webpack_public_path__ + "static/media/participants_icon.cbfbdbd8.svg";